(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-document-type"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-document-type')) {
    class CartDocumentType extends HTMLElement {
      static checkoutSelector = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
      static invoiceAttributeNames = [
        'Factura - RUT',
        'Factura - Giro',
        'Factura - Razón social',
        'Factura - Dirección',
        'Factura - Región',
        'Factura - Comuna',
        'Factura - Correo electrónico'
      ];
      static regionRows = [
        ['Arica y Parinacota', 'Arica|Camarones|General Lagos|Putre'],
        ['Tarapacá', 'Alto Hospicio|Camiña|Colchane|Huara|Iquique|Pica|Pozo Almonte'],
        ['Antofagasta', 'Antofagasta|Calama|María Elena|Mejillones|Ollagüe|San Pedro de Atacama|Sierra Gorda|Taltal|Tocopilla'],
        ['Atacama', 'Alto del Carmen|Caldera|Chañaral|Copiapó|Diego de Almagro|Freirina|Huasco|Tierra Amarilla|Vallenar'],
        ['Coquimbo', 'Andacollo|Canela|Combarbalá|Coquimbo|Illapel|La Higuera|La Serena|Los Vilos|Monte Patria|Ovalle|Paihuano|Punitaqui|Río Hurtado|Salamanca|Vicuña'],
        ['Valparaíso', 'Algarrobo|Cabildo|Calle Larga|Cartagena|Casablanca|Catemu|Concón|El Quisco|El Tabo|Hijuelas|Isla de Pascua|Juan Fernández|La Calera|La Cruz|La Ligua|Limache|Llaillay|Los Andes|Nogales|Olmué|Panquehue|Papudo|Petorca|Puchuncaví|Putaendo|Quillota|Quilpué|Quintero|Rinconada|San Antonio|San Esteban|San Felipe|Santa María|Santo Domingo|Valparaíso|Villa Alemana|Viña del Mar|Zapallar'],
        ['Metropolitana de Santiago', 'Alhué|Buin|Calera de Tango|Cerrillos|Cerro Navia|Colina|Conchalí|Curacaví|El Bosque|El Monte|Estación Central|Huechuraba|Independencia|Isla de Maipo|La Cisterna|La Florida|La Granja|La Pintana|La Reina|Lampa|Las Condes|Lo Barnechea|Lo Espejo|Lo Prado|Macul|Maipú|María Pinto|Melipilla|Ñuñoa|Padre Hurtado|Paine|Pedro Aguirre Cerda|Peñaflor|Peñalolén|Pirque|Providencia|Pudahuel|Puente Alto|Quilicura|Quinta Normal|Recoleta|Renca|San Bernardo|San Joaquín|San José de Maipo|San Miguel|San Pedro|San Ramón|Santiago|Talagante|Tiltil|Vitacura'],
        ["Libertador General Bernardo O'Higgins", 'Chépica|Chimbarongo|Codegua|Coinco|Coltauco|Doñihue|Graneros|La Estrella|Las Cabras|Litueche|Lolol|Machalí|Malloa|Marchigüe|Mostazal|Nancagua|Navidad|Olivar|Palmilla|Paredones|Peralillo|Peumo|Pichidegua|Pichilemu|Placilla|Pumanque|Quinta de Tilcoco|Rancagua|Rengo|Requínoa|San Fernando|San Vicente|Santa Cruz'],
        ['Maule', 'Cauquenes|Chanco|Colbún|Constitución|Curepto|Curicó|Empedrado|Hualañé|Licantén|Linares|Longaví|Maule|Molina|Parral|Pelarco|Pelluhue|Pencahue|Rauco|Retiro|Río Claro|Romeral|Sagrada Familia|San Clemente|San Javier|San Rafael|Talca|Teno|Vichuquén|Villa Alegre|Yerbas Buenas'],
        ['Ñuble', 'Bulnes|Chillán|Chillán Viejo|Cobquecura|Coelemu|Coihueco|El Carmen|Ninhue|Ñiquén|Pemuco|Pinto|Portezuelo|Quillón|Quirihue|Ránquil|San Carlos|San Fabián|San Ignacio|San Nicolás|Trehuaco|Yungay'],
        ['Biobío', 'Alto Biobío|Antuco|Arauco|Cabrero|Cañete|Chiguayante|Concepción|Contulmo|Coronel|Curanilahue|Florida|Hualpén|Hualqui|Laja|Lebu|Los Álamos|Los Ángeles|Lota|Mulchén|Nacimiento|Negrete|Penco|Quilaco|Quilleco|San Pedro de la Paz|San Rosendo|Santa Bárbara|Santa Juana|Talcahuano|Tirúa|Tomé|Tucapel|Yumbel'],
        ['La Araucanía', 'Angol|Carahue|Cholchol|Collipulli|Cunco|Curacautín|Curarrehue|Ercilla|Freire|Galvarino|Gorbea|Lautaro|Loncoche|Lonquimay|Los Sauces|Lumaco|Melipeuco|Nueva Imperial|Padre Las Casas|Perquenco|Pitrufquén|Pucón|Purén|Renaico|Saavedra|Temuco|Teodoro Schmidt|Toltén|Traiguén|Victoria|Vilcún|Villarrica'],
        ['Los Ríos', 'Corral|Futrono|La Unión|Lago Ranco|Lanco|Los Lagos|Máfil|Mariquina|Paillaco|Panguipulli|Río Bueno|Valdivia'],
        ['Los Lagos', 'Ancud|Calbuco|Castro|Chaitén|Chonchi|Cochamó|Curaco de Vélez|Dalcahue|Fresia|Frutillar|Futaleufú|Hualaihué|Llanquihue|Los Muermos|Maullín|Osorno|Palena|Puerto Montt|Puerto Octay|Puerto Varas|Puqueldón|Purranque|Puyehue|Queilén|Quellón|Quemchi|Quinchao|Río Negro|San Juan de la Costa|San Pablo'],
        ['Aysén del General Carlos Ibáñez del Campo', "Aysén|Chile Chico|Cisnes|Cochrane|Coyhaique|Guaitecas|Lago Verde|O'Higgins|Río Ibáñez|Tortel"],
        ['Magallanes y de la Antártica Chilena', 'Antártica|Cabo de Hornos|Laguna Blanca|Natales|Porvenir|Primavera|Punta Arenas|Río Verde|San Gregorio|Timaukel|Torres del Paine']
      ];
      static regions = Object.fromEntries(CartDocumentType.regionRows.map(([region, communes]) => [region, communes.split('|')]));
      static saveTimer;
      static writeQueue = Promise.resolve();

      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('input', this.handleInput.bind(this));
        CartDocumentType.initializeRegionFields(this);
        CartDocumentType.syncFromExistingComponent(this);
        CartDocumentType.toggleInvoiceFields();
        CartDocumentType.updateRutValidity();
        CartDocumentType.updateCheckoutState();
      }

      handleChange(event) {
        if (event.target.matches('input[type="radio"]')) {
          this.handleDocumentTypeChange(event.target.value);
          return;
        }

        if (!event.target.matches('[data-invoice-field]')) return;
        if (event.target.matches('[data-region]')) {
          CartDocumentType.syncRegion(event.target.value);
        } else {
          CartDocumentType.syncField(event.target);
        }
        CartDocumentType.markInvoiceUnsaved();
        CartDocumentType.scheduleInvoiceSave(100);
      }

      handleInput(event) {
        if (!event.target.matches('[data-invoice-field]:not(select)')) return;
        if (event.target.dataset.invoiceField === 'Factura - RUT') {
          event.target.value = event.target.value.toUpperCase().replace(/\s/g, '');
        }
        CartDocumentType.syncField(event.target);
        CartDocumentType.updateRutValidity();
        CartDocumentType.markInvoiceUnsaved();
        CartDocumentType.scheduleInvoiceSave(650);
      }

      async handleDocumentTypeChange(value) {
        CartDocumentType.components().forEach((component) => {
          component.querySelectorAll('input[type="radio"]').forEach((radio) => {
            radio.checked = radio.value === value;
          });
          component.dataset.saved = 'false';
          component.dataset.invoiceSaved = 'false';
        });
        CartDocumentType.clearErrors();
        CartDocumentType.setStatus('');

        const attributes = { 'Tipo de documento': value };
        if (value === 'Boleta') {
          CartDocumentType.clearInvoiceInputs();
          CartDocumentType.invoiceAttributeNames.forEach((name) => {
            attributes[name] = '';
          });
        }

        CartDocumentType.toggleInvoiceFields();
        CartDocumentType.updateCheckoutState();

        try {
          await CartDocumentType.updateCart(attributes);
          if (CartDocumentType.selectedValue() !== value) return;
          CartDocumentType.components().forEach((component) => {
            component.dataset.saved = 'true';
          });
          if (value === 'Factura') {
            CartDocumentType.scheduleInvoiceSave(0);
          } else {
            CartDocumentType.updateCheckoutState();
          }
          document.dispatchEvent(new CustomEvent('cart:document-type-changed', { detail: { value } }));
        } catch (error) {
          CartDocumentType.showError(this, this.dataset.saveErrorMessage);
          CartDocumentType.updateCheckoutState();
        }
      }

      static components() {
        return [...document.querySelectorAll('cart-document-type')];
      }

      static fields(component) {
        return [...component.querySelectorAll('[data-invoice-field]')];
      }

      static initializeRegionFields(component) {
        const region = component.querySelector('[data-region]');
        const selectedRegion = region.dataset.selectedValue;
        Object.keys(CartDocumentType.regions).forEach((name) => region.add(new Option(name, name)));
        if (CartDocumentType.regions[selectedRegion]) region.value = selectedRegion;
        const commune = component.querySelector('[data-commune]');
        CartDocumentType.populateCommunes(component, commune.dataset.selectedValue);
      }

      static populateCommunes(component, selectedValue = '') {
        const region = component.querySelector('[data-region]');
        const commune = component.querySelector('[data-commune]');
        const names = CartDocumentType.regions[region.value] || [];
        const placeholder = region.value ? commune.dataset.chooseCommune : commune.dataset.chooseRegionFirst;
        commune.replaceChildren(new Option(placeholder, ''));
        names.forEach((name) => commune.add(new Option(name, name)));
        if (names.includes(selectedValue)) commune.value = selectedValue;
        commune.disabled = CartDocumentType.selectedValue() !== 'Factura' || !region.value;
      }

      static syncFromExistingComponent(component) {
        const source = CartDocumentType.components().find((item) => item !== component && item.dataset.initialized === 'true');
        if (!source) return;
        const selected = source.querySelector('input[type="radio"]:checked')?.value || '';
        component.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.checked = radio.value === selected;
        });
        const sourceRegion = source.querySelector('[data-region]');
        const sourceCommune = source.querySelector('[data-commune]');
        component.querySelector('[data-region]').value = sourceRegion.value;
        CartDocumentType.populateCommunes(component, sourceCommune.value);
        CartDocumentType.fields(component).forEach((field) => {
          if (field.matches('[data-region], [data-commune]')) return;
          const sourceField = CartDocumentType.fields(source).find((item) => item.dataset.invoiceField === field.dataset.invoiceField);
          if (sourceField) field.value = sourceField.value;
        });
        component.dataset.saved = source.dataset.saved;
        component.dataset.invoiceSaved = source.dataset.invoiceSaved;
      }

      static syncField(source) {
        CartDocumentType.components().forEach((component) => {
          CartDocumentType.fields(component).forEach((field) => {
            if (field !== source && field.dataset.invoiceField === source.dataset.invoiceField) field.value = source.value;
          });
        });
      }

      static syncRegion(value) {
        CartDocumentType.components().forEach((component) => {
          component.querySelector('[data-region]').value = value;
          CartDocumentType.populateCommunes(component);
        });
      }

      static selectedValue() {
        return document.querySelector('cart-document-type input[type="radio"]:checked')?.value || '';
      }

      static toggleInvoiceFields() {
        const isInvoice = CartDocumentType.selectedValue() === 'Factura';
        CartDocumentType.components().forEach((component) => {
          component.querySelector('[data-invoice-fields]').hidden = !isInvoice;
          CartDocumentType.fields(component).forEach((field) => {
            field.disabled = !isInvoice;
          });
          const region = component.querySelector('[data-region]');
          component.querySelector('[data-commune]').disabled = !isInvoice || !region.value;
        });
      }

      static clearInvoiceInputs() {
        CartDocumentType.components().forEach((component) => {
          CartDocumentType.fields(component).forEach((field) => {
            field.value = '';
            field.setCustomValidity('');
          });
          CartDocumentType.populateCommunes(component);
        });
      }

      static validateRut(value) {
        const normalized = value.trim().toUpperCase();
        if (!/^\d{7,8}-[\dK]$/.test(normalized)) return false;
        const [number, verifier] = normalized.split('-');
        let sum = 0;
        let multiplier = 2;
        [...number].reverse().forEach((digit) => {
          sum += Number(digit) * multiplier;
          multiplier = multiplier === 7 ? 2 : multiplier + 1;
        });
        const result = 11 - (sum % 11);
        const expected = result === 11 ? '0' : result === 10 ? 'K' : String(result);
        return verifier === expected;
      }

      static updateRutValidity() {
        CartDocumentType.components().forEach((component) => {
          const rut = CartDocumentType.fields(component).find((field) => field.dataset.invoiceField === 'Factura - RUT');
          const isInvalid = rut.value && !CartDocumentType.validateRut(rut.value);
          rut.setCustomValidity(isInvalid ? component.dataset.invalidRutMessage : '');
        });
      }

      static collectInvoiceAttributes() {
        const component = CartDocumentType.visibleComponent();
        return CartDocumentType.fields(component).reduce((attributes, field) => {
          attributes[field.dataset.invoiceField] = field.value.trim();
          return attributes;
        }, {});
      }

      static invoiceIsComplete() {
        if (CartDocumentType.selectedValue() !== 'Factura') return false;
        CartDocumentType.updateRutValidity();
        const component = CartDocumentType.visibleComponent();
        return CartDocumentType.fields(component).every((field) => field.value.trim() && field.checkValidity());
      }

      static markInvoiceUnsaved() {
        CartDocumentType.components().forEach((component) => {
          component.dataset.invoiceSaved = 'false';
        });
        CartDocumentType.clearErrors();
        CartDocumentType.setStatus('');
        CartDocumentType.updateCheckoutState();
      }

      static scheduleInvoiceSave(delay) {
        window.clearTimeout(CartDocumentType.saveTimer);
        CartDocumentType.saveTimer = window.setTimeout(() => CartDocumentType.saveInvoiceFields(), delay);
      }

      static async saveInvoiceFields() {
        if (CartDocumentType.selectedValue() !== 'Factura') return;
        const attributes = CartDocumentType.collectInvoiceAttributes();
        const snapshot = JSON.stringify(attributes);
        CartDocumentType.markInvoiceUnsaved();
        if (Object.values(attributes).some(Boolean)) CartDocumentType.setStatus('saving');

        try {
          await CartDocumentType.updateCart(attributes);
          if (CartDocumentType.selectedValue() !== 'Factura') return;
          if (JSON.stringify(CartDocumentType.collectInvoiceAttributes()) !== snapshot) return;
          const complete = CartDocumentType.invoiceIsComplete();
          CartDocumentType.components().forEach((component) => {
            component.dataset.invoiceSaved = String(complete);
          });
          CartDocumentType.setStatus(complete ? 'saved' : '');
          CartDocumentType.updateCheckoutState();
        } catch (error) {
          const component = CartDocumentType.visibleComponent();
          CartDocumentType.setStatus('');
          CartDocumentType.showError(component, component.dataset.invoiceSaveErrorMessage);
          CartDocumentType.updateCheckoutState();
        }
      }

      static updateCart(attributes) {
        CartDocumentType.writeQueue = CartDocumentType.writeQueue.catch(() => undefined).then(async () => {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('cart-update-failed');
          return response.json();
        });
        return CartDocumentType.writeQueue;
      }

      static isReady() {
        const selected = CartDocumentType.selectedValue();
        const documentIsSaved = CartDocumentType.components().some((component) => component.dataset.saved === 'true');
        if (!selected || !documentIsSaved) return false;
        if (selected === 'Boleta') return true;
        const invoiceIsSaved = CartDocumentType.components().some((component) => component.dataset.invoiceSaved === 'true');
        return invoiceIsSaved && CartDocumentType.invoiceIsComplete();
      }

      static checkoutControls() {
        return [...document.querySelectorAll(CartDocumentType.checkoutSelector)];
      }

      static setCheckoutDisabled(disabled) {
        CartDocumentType.checkoutControls().forEach((control) => {
          if (disabled) {
            if (!control.disabled && control.getAttribute('aria-disabled') !== 'true') {
              control.dataset.documentTypeDisabled = 'true';
              control.setAttribute('aria-disabled', 'true');
              if ('disabled' in control) control.disabled = true;
            }
            return;
          }
          if (control.dataset.documentTypeDisabled === 'true') {
            delete control.dataset.documentTypeDisabled;
            control.removeAttribute('aria-disabled');
            if ('disabled' in control) control.disabled = false;
          }
        });
      }

      static updateCheckoutState() {
        if (!CartDocumentType.components().length) return;
        CartDocumentType.setCheckoutDisabled(!CartDocumentType.isReady());
      }

      static setStatus(state) {
        CartDocumentType.components().forEach((component) => {
          const status = component.querySelector('[data-invoice-status]');
          const message = state === 'saving' ? component.dataset.savingMessage : component.dataset.savedMessage;
          status.textContent = state ? message : '';
          status.hidden = !state;
        });
      }

      static clearErrors() {
        CartDocumentType.components().forEach((component) => {
          const error = component.querySelector('.cart-document-type__error');
          error.textContent = '';
          error.hidden = true;
        });
      }

      static showError(component, message) {
        const error = component.querySelector('.cart-document-type__error');
        error.textContent = message;
        error.hidden = false;
      }

      static visibleComponent() {
        return CartDocumentType.components().find((component) => component.getClientRects().length > 0) || CartDocumentType.components()[0];
      }

      static blockCheckout(event) {
        if (!CartDocumentType.components().length || CartDocumentType.isReady()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const component = CartDocumentType.visibleComponent();
        const selected = CartDocumentType.selectedValue();
        if (!selected) {
          CartDocumentType.showError(component, component.dataset.requiredMessage);
          component.querySelector('input[type="radio"]')?.focus();
          return;
        }
        CartDocumentType.showError(component, component.dataset.invoiceRequiredMessage);
        CartDocumentType.updateRutValidity();
        const invalidField = CartDocumentType.fields(component).find((field) => !field.value.trim() || !field.checkValidity());
        invalidField?.focus();
        invalidField?.reportValidity();
      }
    }

    customElements.define('cart-document-type', CartDocumentType);

    document.addEventListener('click', (event) => {
      if (event.target.closest(CartDocumentType.checkoutSelector)) CartDocumentType.blockCheckout(event);
    }, true);

    document.addEventListener('submit', (event) => {
      if (event.submitter?.matches(CartDocumentType.checkoutSelector)) CartDocumentType.blockCheckout(event);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
